import * as React from "react";
import Analytics from "../../../../../Foundation/Analytics/code/Scripts/Analytics";

interface ITupasLoginButtonProps {
    formAction: string;
    jweAppId?: string;
    jweToken?: string;
    texts: string;
    displayDisabledButton?: boolean;
    className?: string;
    componentDidMount: () => void;
    componentWillUnmount: () => void;
    onClick?: () => void;
}

export default class TupasLoginButton extends React.Component<ITupasLoginButtonProps, {}> {
    constructor(props: ITupasLoginButtonProps) {
        super(props);
    }

    public render() {
        const { texts, displayDisabledButton, className, jweAppId, jweToken } = this.props;
        return displayDisabledButton
            ? (
                <a className="yellow-button disabled">{texts}</a>
            )
            : (
                <form
                    name="tupasLoginForm"
                    id="tupasLoginForm"
                    method="POST"
                    action={this.props.formAction}
                    target="_blank"
                >
                    <input
                        name={"token"}
                        type="hidden"
                        aria-hidden="true"
                        value={jweToken}
                    />
                    <input
                        name="lang"
                        type="hidden"
                        aria-hidden="true"
                        value="fi"
                    />
                    <input
                        name="appid"
                        type="hidden"
                        aria-hidden="true"
                        value={jweAppId}
                    />
                    <button type="submit" onClick={() => { if(this.props.onClick) this.props.onClick() } } className={"yellow-button " + className}>
                        {texts}
                    </button>
                </form>
            );
    }


    public componentDidMount() {
        if (this.props.componentDidMount) {
            var pageID = document.getElementById("pageID") as HTMLInputElement;
            var analytics = new Analytics();
            analytics.ButtonClick(pageID.value);
            this.props.componentDidMount();
        }
    }

    public componentWillUnmount() {
        if (this.props.componentWillUnmount) {
            this.props.componentWillUnmount();
        }
    }
}
